export const notificationEndpoints = {
  getNotifications: '/private/v1/notifications',
  getSixNotifications: (id: string) => `/private/v1/notifications/${id}`,
} as const;

export type NotificationEndpointKey = keyof typeof notificationEndpoints;
